import * as React from 'react'
import {theme} from '../theme'
import styled from 'styled-components'

export interface ISeparatorProps {
  className?: string
  padding?: string
  margin?: string
  color?: string
}

const SeparatorElement = (props: ISeparatorProps) => {
  return <div className={props.className} />
}

export const Separator = styled(SeparatorElement)`
  margin: ${props => props.margin || '0.8rem auto'};
  padding: ${props => props.padding || 0};
  background-color: ${props => props.color || theme.color.gray};
  height: 1px;
  width: 100%;
`
